/* eslint-disable jsx-a11y/anchor-is-valid */
import { css } from '@emotion/css'
import moment from 'moment'
import { useEffect, useMemo, useRef, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks/customReducer'
import { translate } from '../../../../../base/localization'
import { uuidv4 } from '../../../../../base/utils'
import { getDateByTimezoneOffset } from '../../../../../base/utils/dataHelper'
import IPButton from '../../../../../components/IPButton'
import IPInput from '../../../../../components/IPInput'
import IPModal from '../../../../../components/IPModal'
import IPSelectBox from '../../../../../components/IPSelectBox'
import { ISelectOption } from '../../../../../components/IPSelectBox/IPSelectBox'
import InputCampaign from '../../../../../components/InputCampaign'
import Table from '../../../../../components/Table'
import Translations from '../../../../../translations'
import { CommonPostResponse, IBanks, ICompany } from '../../../components/models/models'
import {
  BankInstallmentHistoryModel,
  BankInstallmentHistoryResponseModel,
  IBank,
  IInstallemnt,
  InstallmentFilterRequestModel,
  IPostInstallment,
} from '../models/models'
import { DeleteInstallemntsApi } from '../services/deleteInstallemntsApi'
import { ListInstallemntsApi } from '../services/listInstallemnts'
import { UpdateInstallemntsApi } from '../services/updateInstallemntsApi'
import { getBanksApi, getCompanyApi } from '../../../components/api'

interface IInstallemntState {
  companies: ISelectOption[]
  searchCompanies: ISelectOption[]
  selectedCompany?: ISelectOption | undefined
  selectedType?: ISelectOption | undefined
}
const types = [
  { label: 'Avantaj Pos', value: '0' },
  { label: 'Fırsat POS', value: '1' },
  { label: 'FÇV2', value: '2' },
  { label: 'Cari Ödeme', value: '3' },
]

const operationLabels: Record<string, string> = {
  Insert: 'Oluşturma',
  Update: 'Güncelleme',
  Delete: 'Silme',
}

/** Eski tarihçe kayıtlarında işlem tipi yok; boş bırakmak yerine tire göster. */
const operationLabel = (operationType?: string | null): string => {
  if (!operationType) return '–'
  return operationLabels[operationType] ?? operationType
}

/** Tarihçedeki tarih alanları eski kayıtlarda undefined gelebilir. */
const formatHistoryDate = (value?: string | Date | null): string => {
  if (!value) return '–'
  const parsed = moment(value)
  return parsed.isValid() ? parsed.format('DD.MM.YYYY HH:mm:ss') : '–'
}

/**
 * Tarihçe modalları çok kolonlu; ekranın izin verdiği kadar geniş açılsınlar.
 * IPModal genişliği sabit px bastığı için viewport'tan taşmaması adına burada sınırlıyoruz.
 */
const historyModalWidth = (max: number): number =>
  typeof window === 'undefined' ? max : Math.min(max, window.innerWidth - 40)

function BankUpdateDel(props: BaseComponentWithContextProps) {
  const [searchParams, setSearchParams] = useSearchParams()

  const searchCompany = searchParams.get('Sirket')
  const searchType = searchParams.get('Tip')
  const searchSearch = searchParams.get('Arama')
  const searchStart = searchParams.get('Baslangic')
  const searchEnd = searchParams.get('Bitis')

  const [bankInstallment, setBankInstallment] = useState<IInstallemnt[]>([])

  const [searchQuery, setSearchQuery] = useState(searchSearch ? searchSearch : '')
  const t = translate(Translations)
  const tableRef = useRef<any>()
  const [bank, setBank] = useState<IBank[]>([])
  const [showDetail, setShowDetail] = useState<boolean>(false)
  const [installmentDeleted, setInstallmentDeleted] = useState<boolean>(false)
  const [showBankInstallmentHistory, setShowBankInstallmentHistory] = useState<boolean>(false)
  const [showInstallmentHistory, setBankInstallmentHistory] = useState<boolean>(false)
  const [allHistory, setAllHistory] = useState<BankInstallmentHistoryResponseModel[]>([])
  const [installmentHistory, setInstallmentHistory] = useState<BankInstallmentHistoryModel[]>([])

  const [selectedGroup, setSelectedGroup] = useState<IInstallemnt | undefined>()
  const [detailBanks, setDetailBanks] = useState<ISelectOption[]>([])
  const [editingBankGroupId, setEditingBankGroupId] = useState<string | undefined>()
  const [editInstalmentRate, setEditInstalmentRate] = useState<ISelectOption | undefined>()
  const [editTermDay, setEditTermDay] = useState<string>('')
  const [newBank, setNewBank] = useState<ISelectOption | undefined>()
  const [newInstalmentRate, setNewInstalmentRate] = useState<ISelectOption | undefined>()
  const [newTermDay, setNewTermDay] = useState<string>('')

  const installmentAddNum = ['1', '2', '3', '4', '5', '6', '9', '12', '15', '18', '24'].map(value => ({
    value,
    label: t('pages.admin.BankAndInstallementOperation.bankCrud.bankAdd.installment', [value]),
  }))

  const getInitialState = (): IInstallemntState => {
    return {
      companies: [],
      searchCompanies: [],
      selectedCompany: undefined,
      selectedType: searchType
        ? {
          label: types.find(a => a.label === searchType)?.label || '',
          value: types.find(a => a.label === searchType)?.value || 0,
        }
        : undefined,
    }
  }

  const initialState = getInitialState()
  const [state, setState] = useCustomReducer<IInstallemntState>(initialState)

  // Tarih ve saat ayarları
  const inititalStartDate = new Date()
  inititalStartDate.setDate(1)
  inititalStartDate.setHours(0)
  inititalStartDate.setMinutes(0)
  inititalStartDate.setSeconds(0)

  const toDateTimeLocal = date => {
    return date
      .toLocaleString('sv-SE', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
      .replace(' ', 'T')
  }
  // Klavyeden tarih ve saat girebilmeye imkan veren fonksiyon
  const getDate = async (data: any, title: string) => {
    if (title === 'Start') setStartDate(data)
    else setEndDate(data)
  }

  const [startDate, setStartDate] = useState(searchStart ? searchStart : toDateTimeLocal(inititalStartDate))
  const [endDate, setEndDate] = useState(searchEnd ? searchEnd : toDateTimeLocal(new Date()))

  useEffect(
    () => {
      listInstallemnts('Listeleme')
    },
    [
      //searchQuery, state.selectedCompany, state.companies, state.selectedType
    ]
  )

  useEffect(() => {
    getCompanies()
  }, [])

  useEffect(() => {
    if (state.companies.length > 0 && searchCompany) {
      const selectedCompany = state.companies.find(a => a.label === searchCompany)
      if (selectedCompany) {
        setState({ selectedCompany })
      }
    }
  }, [state.companies])

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Code.toString(),
      }))
      setState({ companies: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }

  const listInstallemnts = async type => {
    // Sirket/Tip parametreleri kendi onChange handler'larında yönetiliyor;
    // burada sadece Arama/Baslangic/Bitis güncellenir, mevcut Sirket/Tip korunur.
    const nextParams = new URLSearchParams(searchParams)
    if (searchQuery !== '' && searchQuery != null) nextParams.set('Arama', searchQuery)
    else nextParams.delete('Arama')
    if (startDate) nextParams.set('Baslangic', String(startDate))
    else nextParams.delete('Baslangic')
    if (endDate) nextParams.set('Bitis', String(endDate))
    else nextParams.delete('Bitis')
    setSearchParams(nextParams, { replace: true })

    const startDateValid = startDate && (getDateByTimezoneOffset(startDate as Date) as any)
    const endDateValid = endDate && (getDateByTimezoneOffset(endDate as Date) as any)

    if (startDateValid && endDateValid) {
      const req: InstallmentFilterRequestModel = {
        StartDate: startDateValid,
        EndDate: endDateValid,
      }
      props.showLoading()
      const listInstallemntsApi: ListInstallemntsApi = new ListInstallemntsApi({})
      listInstallemntsApi
        .listInstallemnts(req)
        .then(res => {
          if (res) {
            props.hideLoading()
            const data: IInstallemnt[] = []
            res.map(ins => {
              const bank: IBank[] = []
              ins.ModelList.map(model => {
                return bank.push({
                  Id: model.Id,
                  BankId: model.BankId,
                  BankName: model.BankName,
                  Installment: model.Installment,
                  InterestRate: model.InterestRate,
                  BankGroupId: model.BankGroupId,
                  History: model.History,
                  Deleted: model.Deleted,
                })
              })
              data.push({
                GroupId: ins.GroupId,
                Company: ins.ModelList[0].Company,
                Type: ins.ModelList[0].Type,
                StartDate: ins.ModelList[0].StartDate,
                EndDate: ins.ModelList[0].EndDate,
                PaymentTermsId: ins.ModelList[0].PaymentTermsId,
                PaymentTermsName: ins.ModelList[0].PaymentTermsName,
                Bank: bank,
                History: '',
                AllHistory: ins.AllHistory,
              })
            })
            if (type === 'Listeleme') {
              return setBankInstallment(data)
            } else if (type === 'Güncelleme') {
              setBankInstallment(data)
            }
            tableRef.current?.clear()
            tableRef.current?.rows
              .add(
                data.map(dt => {
                  return {
                    GroupId: dt.GroupId,
                    Company: state.companies.find(c => c.value.toString() === dt.Company.toString())?.label || '',
                    Start: new Date(dt.StartDate).toLocaleDateString('tr-TR'),
                    End: new Date(dt.EndDate).toLocaleDateString('tr-TR'),
                    PaymentTermsName: dt.PaymentTermsName,
                    Type:
                      dt.Type === '0'
                        ? 'Avantaj POS'
                        : dt.Type === '1'
                          ? 'Fırsat POS'
                          : dt.Type === '2'
                            ? 'FÇV2'
                            : dt.Type === '3'
                              ? 'Cari Ödeme'
                              : '',
                  }
                })
              )
              .draw(true)
          }
        })
        .catch((err: any) => {
          tableRef.current?.clear().draw(true)
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
          props.hideLoading()
        })
    } else {
      // Dates are not valid, show a warning
      Swal.fire({
        title: 'Geçersiz Tarih',
        text: 'Lütfen geçerli başlangıç ve bitiş tarihleri giriniz.',
        icon: 'warning',
        confirmButtonText: 'Tamam',
      })
    }
  }

  const [deleteInstallementloadingId, setDeleteInstallementLoadingId] = useState<string | null>(null) // Yükleme durumunu takip eden state

  const deleteInstallement = async (groupId: string) => {
    const confirmResult = await Swal.fire({
      icon: 'warning',
      title: 'Emin misiniz?',
      text: 'Banka taksitini silmek istediğinizden emin misiniz?',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, Sil',
      cancelButtonText: 'İptal',
      allowOutsideClick: false,
    })

    if (confirmResult.isConfirmed) {
      setDeleteInstallementLoadingId(groupId) // Yükleme durumunu başlat

      var data = bankInstallment.find(auth => auth.GroupId === groupId)
      const request: number[] = data ? data.Bank.map(b => Number(b.Id)) : [0]

      const deleteInstallemnts: DeleteInstallemntsApi = new DeleteInstallemntsApi({})
      deleteInstallemnts
        .deleteInstallemnts(request)
        .then((result: CommonPostResponse) => {
          if (result) {
            Swal.fire({
              icon: 'success',
              title: 'Banka Taksit Silindi',
              showConfirmButton: true,
              allowOutsideClick: false,
            }).then(async result => {
              if (result) listInstallemnts('Güncelleme')
            })
          }
        })
        .catch((err: any) => {
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        })
        .finally(() => {
          setDeleteInstallementLoadingId(null) // Yükleme durumunu bitir
        })
    }
  }

  const [deleteBankloadingId, setDeleteBankLoadingId] = useState<number | null>(null) // Silme işlemi sırasında yükleme durumunu tutan state

  const deleteBank = async (id: number, bankName: string, installment: number) => {
    const confirmResult = await Swal.fire({
      icon: 'warning',
      title: 'Emin misiniz?',
      text: `${bankName} bankasının "${installment}" taksitini silmek istediğinizden emin misiniz?`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, Sil',
      cancelButtonText: 'İptal',
      allowOutsideClick: false,
    })

    if (confirmResult.isConfirmed) {
      setDeleteBankLoadingId(id) // Silme işlemi başladığında loadingId'yi güncelle

      const deleteInstallemnts: DeleteInstallemntsApi = new DeleteInstallemntsApi({})
      deleteInstallemnts
        .deleteInstallemnts([id])
        .then((result: CommonPostResponse) => {
          if (result) {
            Swal.fire({
              icon: 'success',
              title: `${bankName} bankasının "${installment}" taksiti Silindi!`,
              showConfirmButton: true,
              allowOutsideClick: false,
            }).then(async result => {
              if (result) setInstallmentDeleted(true)

              if (bank.length === 1) return setShowDetail(false)

              setBank(bank.filter(b => b.Id !== id))
            })
          }
        })
        .catch((err: any) => {
          Swal.fire({
            icon: 'error',
            title: err.description,
            showConfirmButton: true,
            allowOutsideClick: false,
          })
        })
        .finally(() => {
          setDeleteBankLoadingId(null) // Silme işlemi tamamlandığında loadingId'yi sıfırla
        })
    }
  }

  const fetchBankInstallmentList = async (): Promise<IInstallemnt[]> => {
    const startDateValid = startDate && (getDateByTimezoneOffset(startDate as any) as any)
    const endDateValid = endDate && (getDateByTimezoneOffset(endDate as any) as any)
    if (!startDateValid || !endDateValid) return bankInstallment

    const req: InstallmentFilterRequestModel = { StartDate: startDateValid, EndDate: endDateValid }
    const res = await new ListInstallemntsApi({}).listInstallemnts(req)
    return (res || []).map(ins => ({
      GroupId: ins.GroupId,
      Company: ins.ModelList[0].Company,
      Type: ins.ModelList[0].Type,
      StartDate: ins.ModelList[0].StartDate,
      EndDate: ins.ModelList[0].EndDate,
      PaymentTermsId: ins.ModelList[0].PaymentTermsId,
      PaymentTermsName: ins.ModelList[0].PaymentTermsName,
      Bank: ins.ModelList.map(model => ({
        Id: model.Id,
        BankId: model.BankId,
        BankName: model.BankName,
        Installment: model.Installment,
        InterestRate: model.InterestRate,
        BankGroupId: model.BankGroupId,
        History: model.History,
        Deleted: model.Deleted,
      })),
      History: '',
      AllHistory: ins.AllHistory,
    }))
  }

  const persistBankChange = async (banks: IBank[]) => {
    if (!selectedGroup) return
    // Silinmiş satırlar listede yalnızca tarihçeleri görünsün diye duruyor. Geri
    // gönderilirlerse backend kaydı bulamayıp yeni taksit olarak yeniden ekler.
    const data: IPostInstallment[] = banks
      .filter(b => !b.Deleted)
      .map(b => ({
        Id: b.Id,
        Type: selectedGroup.Type,
        DealerCodes: [],
        Company: selectedGroup.Company,
        Installment: b.Installment,
        BankName: b.BankName,
        InterestRate: b.InterestRate,
        StartDate: selectedGroup.StartDate,
        EndDate: selectedGroup.EndDate,
        BankId: b.BankId,
        PaymentTermsId: selectedGroup.PaymentTermsId,
        BankGroupId: b.BankGroupId,
      }))
    props.showLoading()
    try {
      await new UpdateInstallemntsApi({}).updateInstallemnts(data)
      const list = await fetchBankInstallmentList()
      setBankInstallment(list)
      const updatedGroup = list.find(g => g.GroupId === selectedGroup.GroupId)
      setBank(updatedGroup?.Bank || [])
      setSelectedGroup(updatedGroup)
      setEditingBankGroupId(undefined)
      setEditInstalmentRate(undefined)
      setEditTermDay('')
      setNewBank(undefined)
      setNewInstalmentRate(undefined)
      setNewTermDay('')
      Swal.fire({ icon: 'success', title: 'İşlem başarılı', showConfirmButton: true, allowOutsideClick: false })
    } catch (err: any) {
      Swal.fire({ icon: 'error', title: err.description, showConfirmButton: true, allowOutsideClick: false })
    } finally {
      props.hideLoading()
    }
  }

  const startEditBank = (b: IBank) => {
    setEditingBankGroupId(b.BankGroupId)
    setEditInstalmentRate(installmentAddNum.find(o => String(o.value) === String(b.Installment)) || { value: String(b.Installment), label: String(b.Installment) })
    setEditTermDay(String(b.InterestRate))
  }

  const cancelEditBank = () => {
    setEditingBankGroupId(undefined)
    setEditInstalmentRate(undefined)
    setEditTermDay('')
  }

  const saveEditBank = () => {
    if (!editInstalmentRate || !editTermDay) {
      Swal.fire({ icon: 'error', title: 'Lütfen boş alan bırakmayınız', showConfirmButton: true, allowOutsideClick: false })
      return
    }
    const updatedBanks = bank.map(b =>
      b.BankGroupId === editingBankGroupId ? { ...b, Installment: Number(editInstalmentRate.value), InterestRate: Number(editTermDay) } : b
    )
    persistBankChange(updatedBanks)
  }

  const addDetailBank = () => {
    if (!newBank || !newInstalmentRate || !newTermDay) {
      Swal.fire({ icon: 'error', title: 'Lütfen boş alan bırakmayınız', showConfirmButton: true, allowOutsideClick: false })
      return
    }
    const newItem: IBank = {
      Id: 0,
      BankId: String(newBank.value),
      BankName: String(newBank.label),
      Installment: Number(newInstalmentRate.value),
      InterestRate: Number(newTermDay),
      BankGroupId: uuidv4(),
      History: null,
    }
    persistBankChange([...bank, newItem])
  }

  const navigate: any = useNavigate()
  const updateInstallement = async (groupId: string) => {
    var dt = bankInstallment.find(auth => {
      return auth.GroupId === groupId
    })
    // Silinmiş satırlar düzenleme ekranına taşınmaz; oradan geri gönderilirlerse
    // backend kaydı bulamayıp yeni taksit olarak yeniden ekler.
    const editable = dt ? { ...dt, Bank: dt.Bank.filter(b => !b.Deleted) } : dt
    navigate('/admin/BankAndInstallementOperation/BankCrud/add', {
      state: { installementData: editable, url: searchParams.toString() },
    })
  }

  //#region Tablo Kolonları ve Filtreleme
  const columns = useMemo(
    () => [
      {
        Header: 'Şirket',
        accessor: 'Company',
      },
      {
        Header: 'Tip',
        accessor: 'Type',
      },
      {
        Header: 'Kampanya Adı',
        accessor: 'PaymentTermsName',
      },
      {
        Header: 'Detay',
        accessor: 'Detail',
      },
      {
        Header: 'Başlangıç Tarihi',
        accessor: 'Start',
      },
      {
        Header: 'Bitiş Tarihi',
        accessor: 'End',
      },
      {
        Header: 'Değişiklikler',
        accessor: 'LastAction',
      },
      {
        Header: 'İşlemler',
        accessor: 'Actions',
      },
    ],
    []
  )

  const filteredData = useMemo(() => {
    let filteredByCompany = bankInstallment
    if (state.selectedCompany?.value !== undefined) {
      filteredByCompany = bankInstallment.filter(dt => dt.Company === state.selectedCompany?.value)
    } else {
      filteredByCompany = bankInstallment
    }

    let filteredByType = filteredByCompany
    if (state.selectedType?.value !== undefined) {
      filteredByType = filteredByCompany.filter(dt => dt.Type === state.selectedType?.value)
    }

    let filteredBySearchQuery = filteredByType.filter(dt => {
      if (searchQuery === '') return true
      return (
        dt.Company.toLowerCase().includes(searchQuery.toLowerCase()) ||
        dt.PaymentTermsName.toLowerCase().includes(searchQuery.toLowerCase()) ||
        dt.Bank.map(b => b.BankName.toLowerCase()).some(name => name.includes(searchQuery.toLowerCase()))
      )
    })

    return filteredBySearchQuery.map(dt => {
      return {
        Company: state.companies.find(c => c.value.toString() === dt.Company.toString())?.label || '',
        Type:
          dt.Type === '0'
            ? 'Avantaj POS'
            : dt.Type === '1'
              ? 'Fırsat POS'
              : dt.Type === '2'
                ? 'FÇV2'
                : dt.Type === '3'
                  ? 'Cari Ödeme'
                  : '',
        PaymentTermsName: dt.PaymentTermsName,
        Detail: (
          <IPButton
            text='Detay'
            onClick={async () => {
              var datas = bankInstallment.find(auth => {
                return auth.GroupId === dt.GroupId
              })
              datas?.Bank.sort((a, b) => Number(a.BankId) - Number(b.BankId))
              if (datas) {
                setBank(datas.Bank)
                setSelectedGroup(datas)
                try {
                  const banks: IBanks[] = await getBanksApi(String(datas.Company))
                  setDetailBanks(banks.map(b => ({ value: b.BankID, label: b.BankName })))
                } catch {
                  setDetailBanks([])
                }
              }
              setShowDetail(true)
            }}
            type='button'
            style={{ padding: '0px', width: '120px', height: '30px', color: 'white', borderColor: 'red' }}
            className='btn btn-danger'
          ></IPButton>
        ),
        Start: new Date(dt.StartDate).toLocaleString('tr-TR'),
        End: new Date(dt.EndDate).toLocaleString('tr-TR'),
        LastAction: (
          <IPButton
            text='Tarihçe'
            onClick={() => {
              setShowBankInstallmentHistory(true)
              var selectedData = bankInstallment.find(auth => auth.GroupId === dt.GroupId)
              if (selectedData) {
                const { AllHistory } = selectedData

                if (AllHistory && AllHistory.length > 0) {
                  setAllHistory(AllHistory)
                } else {
                  setAllHistory([])
                }
              } else {
                setAllHistory([])
              }
            }}
            type='button'
            style={{ padding: '0px', width: '120px', height: '30px', color: 'white', borderColor: 'red' }}
            className='btn btn-danger'
          ></IPButton>
        ),
        Actions: (
          <>
            <a
              onClick={() => updateInstallement(dt.GroupId)}
              data-action-type='edit'
              role='button'
              className={css`
                cursor: pointer;
              `}
              data-toggle='tooltip'
              data-original-title={t('pages.mySpecial.userUpdate.edit')}
            >
              <i
                className={`${css`
                  font-size: 1.2rem;
                  color: green;
                `} icon-edit`}
              ></i>
            </a>
            <a
              data-action-type='copy'
              role='button'
              style={{ cursor: 'pointer' }}
              data-toggle='tooltip'
              data-original-title='Kopyala'
              onClick={() => {
                navigate('/admin/BankAndInstallementOperation/BankCrud/add', {
                  state: { installementData: dt, flag: 'copy', url: searchParams.toString() },
                })
              }}
            >
              <i className='icon-copy' style={{ fontSize: '1.2rem', color: 'blue' }}></i>
            </a>
            <a
              onClick={() => deleteInstallement(dt.GroupId)}
              data-action-type='delete'
              role='button'
              className={css`
                cursor: pointer;
              `}
              data-toggle='tooltip'
              data-original-title={t('pages.mySpecial.userUpdate.delete')}
            >
              {deleteInstallementloadingId === dt.GroupId ? (
                <i
                  className={`${css`
                    font-size: 1.2rem;
                    color: gray;
                  `} fas fa-spinner fa-spin`}
                ></i>
              ) : (
                <i
                  className={`${css`
                    font-size: 1.2rem;
                    color: red;
                  `} icon-trash-2`}
                ></i>
              )}
            </a>
          </>
        ),
      }
    })
  }, [bankInstallment, state.selectedCompany, state.selectedType, searchQuery, deleteInstallementloadingId])
  //#endregion

  return (
    <div className='container'>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'>Banka Taksit Listeleme</span>
            <div className='col-12 col-md-2 mb-2'>
              <label className='p-switch switch-color-success'>
                <Link to='/admin/BankAndInstallementOperation/BankCrud/add' state={{ url: searchParams.toString() }}>
                  <IPButton
                    text={'Banka Taksit ' + t('pages.admin.BankAndInstallementOperation.bankCrud.bankUpdateDel.add')}
                    className='btn btn-primary'
                    style={{ height: '45px', marginLeft: '15px' }}
                  />
                </Link>
              </label>
            </div>
          </div>
          <div className='card-body'>
            <div className='row align-items-center'>
              <div className='col-12 col-md-3 mb-3'>
                <InputCampaign
                  type='datetime-local'
                  id='StartDate'
                  name='StartDate'
                  label={'Başlangıç Tarihi'}
                  value={startDate && toDateTimeLocal(startDate)}
                  onChange={e => getDate(e.target.value, 'Start')}
                  isActive
                />
              </div>
              <div className='col-12 col-md-3 mb-3'>
                <InputCampaign
                  type='datetime-local'
                  id='EndDate'
                  name='EndDate'
                  label={'Bitiş Tarihi'}
                  value={endDate && toDateTimeLocal(endDate)}
                  onChange={e => getDate(e.target.value, 'End')}
                  isActive
                />
              </div>
              <div className='col-12 col-md-2 mb-3'>
                <IPButton text='Göster' className='btn btn-danger' onClick={() => listInstallemnts('Listeleme')} />
              </div>
            </div>

            <div className='row align-items-center'>
              <div className='col-md-3'>
                <form>
                  <IPSelectBox
                    isClearable
                    id='Şirket'
                    name='Şirket'
                    placeholder='Şirket seçiniz...'
                    options={state.companies}
                    value={state.selectedCompany}
                    onChangeSingle={option => {
                      setState({ selectedCompany: option })
                      setSearchParams(prev => {
                        const p = new URLSearchParams(prev)
                        if (option) p.set('Sirket', String(option.label))
                        else p.delete('Sirket')
                        return p
                      }, { replace: true })
                    }}
                  />
                </form>
              </div>
              <div className='col-md-3'>
                <form>
                  <IPSelectBox
                    isClearable
                    id='Şirket'
                    name='Şirket'
                    placeholder='Tip Seçiniz...'
                    options={types}
                    value={state.selectedType}
                    onChangeSingle={option => {
                      setState({ selectedType: option })
                      setSearchParams(prev => {
                        const p = new URLSearchParams(prev)
                        if (option) p.set('Tip', String(option.label))
                        else p.delete('Tip')
                        return p
                      }, { replace: true })
                    }}
                  />
                </form>
              </div>
              <div className='col-md-6'>
                <form>
                  <div className='input-group'>
                    <input
                      type='text'
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      placeholder='Arama...'
                      className='form-control'
                      style={{ height: '45px' }}
                    />
                    <div className='input-group-append'>
                      <span className='input-group-text'>
                        <i className='fa fa-search'></i>
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div id='datatable_wrapper' className='dataTables_wrapper dt-bootstrap4' style={{ padding: '10px' }}>
                <div className='row'>
                  <div className='col-sm-12 pr-4' style={{ overflowX: 'auto' }}>
                    <Table columns={columns} data={filteredData} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <IPModal
        show={showDetail}
        onClose={() => {
          setShowDetail(false)
          setEditingBankGroupId(undefined)
          setEditInstalmentRate(undefined)
          setEditTermDay('')
          setNewBank(undefined)
          setNewInstalmentRate(undefined)
          setNewTermDay('')
          if (installmentDeleted) {
            listInstallemnts('Güncelleme')
            setInstallmentDeleted(false)
          }
        }}
        hideConfirm={true}
        width={1000}
        title='Banka Taksit Detay'
      >
        <table
          id='datatable'
          className='table table-bordered table-hover dataTable'
          role='grid'
          aria-describedby='datatable_info'
        >
          <thead className='tableodd'>
            <tr role='row'>
              <th>#</th>
              <th>Banka Adı</th>
              <th>Taksit</th>
              <th>Vade(max)</th>
              <th>İşlem</th>
            </tr>
          </thead>
          <tbody>
            {bank && bank.length > 0
              ? bank.map((ba, index) => (
                <tr role='row' className='odd' key={ba.BankGroupId || ba.Id}>
                  <td>{index + 1}</td>
                  {editingBankGroupId === ba.BankGroupId ? (
                    <>
                      <td>{ba.BankName}</td>
                      <td style={{ minWidth: '160px' }}>
                        <IPSelectBox
                          isClearable
                          menuPortalTarget={document.body}
                          options={installmentAddNum}
                          value={editInstalmentRate}
                          onChangeSingle={option => setEditInstalmentRate(option)}
                        />
                      </td>
                      <td style={{ minWidth: '120px' }}>
                        <IPInput
                          name='editTermDay'
                          type='text'
                          value={editTermDay}
                          onChange={e => setEditTermDay(e.target.value?.replace(',', '.'))}
                        />
                      </td>
                      <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                        <a onClick={saveEditBank} role='button' style={{ cursor: 'pointer' }} data-toggle='tooltip' data-original-title='Kaydet'>
                          <i className='icon-check' style={{ fontSize: '15px', color: 'green' }}></i>
                        </a>
                        <a onClick={cancelEditBank} role='button' style={{ cursor: 'pointer', marginLeft: '8px' }} data-toggle='tooltip' data-original-title='İptal'>
                          <i className='icon-x' style={{ fontSize: '15px', color: 'gray' }}></i>
                        </a>
                      </td>
                    </>
                  ) : (
                    <>
                      <td>
                        {ba.BankName}
                        {ba.Deleted && (
                          <span
                            className='badge badge-danger ml-2'
                            title='Bu taksit silinmiş; tarihçesine erişilebilsin diye listede tutuluyor.'
                          >
                            Silinmiş
                          </span>
                        )}
                      </td>
                      <td>{ba.Installment}</td>
                      <td>{ba.InterestRate}</td>
                      <td
                        style={{
                          textAlign: 'center',
                          verticalAlign: 'middle',
                        }}
                      >
                        <a
                          title='Tarihçe'
                          className='ml-2'
                          data-toggle='tooltip'
                          style={{
                            cursor: 'pointer',
                            color: 'blue',
                            fontSize: '15px',
                          }}
                          onClick={() => {
                            // Eskiden en yeni kayıt en altta kalıyordu; son değişiklik üstte olsun.
                            const history = Array.isArray(ba.History) ? [...ba.History] : []
                            history.sort(
                              (a, b) => new Date(b.ChangeDate).getTime() - new Date(a.ChangeDate).getTime()
                            )
                            setInstallmentHistory(history)
                            setBankInstallmentHistory(true)
                          }}
                        >
                          <i className='icon-clock' style={{ fontSize: '15px' }}></i>
                        </a>
                        {/* Silinmiş satır yalnızca tarihçesi için listede; düzenlenip
                            silinemez, aksi hâlde backend onu yeni taksit olarak geri ekler. */}
                        {!ba.Deleted && (
                          <>
                            <a title='Düzenle' className='ml-2' data-toggle='tooltip' style={{ cursor: 'pointer' }} onClick={() => startEditBank(ba)}>
                              <i className='icon-edit' style={{ fontSize: '15px', color: 'green' }}></i>
                            </a>
                            <a title='Sil' onClick={() => deleteBank(ba.Id, ba.BankName, ba.Installment)}>
                              {deleteBankloadingId === ba.Id ? (
                                <i className='fas fa-spinner fa-spin' style={{ fontSize: '15px', color: 'gray' }}></i>
                              ) : (
                                <i
                                  className='icon-trash-2'
                                  style={{
                                    fontSize: '15px',
                                    color: 'red',
                                    cursor: 'pointer',
                                  }}
                                ></i>
                              )}
                            </a>
                          </>
                        )}
                      </td>
                    </>
                  )}
                </tr>
              ))
              : ''}
            <tr role='row' className='even'>
              <td></td>
              <td style={{ minWidth: '180px' }}>
                <IPSelectBox
                  isClearable
                  menuPortalTarget={document.body}
                  placeholder='Banka'
                  options={detailBanks}
                  value={newBank}
                  onChangeSingle={option => setNewBank(option)}
                />
              </td>
              <td style={{ minWidth: '160px' }}>
                <IPSelectBox
                  isClearable
                  menuPortalTarget={document.body}
                  placeholder='Taksit'
                  options={installmentAddNum}
                  value={newInstalmentRate}
                  onChangeSingle={option => setNewInstalmentRate(option)}
                />
              </td>
              <td style={{ minWidth: '120px' }}>
                <IPInput
                  name='newTermDay'
                  type='text'
                  placeholder='Vade'
                  value={newTermDay}
                  onChange={e => setNewTermDay(e.target.value?.replace(',', '.'))}
                />
              </td>
              <td>
                <IPButton
                  text='Ekle'
                  type='button'
                  style={{ padding: '0px', width: '80px', height: '30px' }}
                  className='btn btn-success'
                  onClick={addDetailBank}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </IPModal>
      <IPModal
        show={showBankInstallmentHistory}
        onClose={() => setShowBankInstallmentHistory(false)}
        hideConfirm={true}
        width={historyModalWidth(1900)}
        title='Banka Taksit Tarihçe'
      >
        <div style={{ overflowX: 'auto' }}>
        <table
          id='datatable'
          className='table table-bordered table-hover dataTable'
          role='grid'
          aria-describedby='datatable_info'
          style={{ whiteSpace: 'nowrap' }}
        >
          <thead className='tableodd'>
            <tr role='row'>
              <th>Değişiklik Tarihi</th>
              <th>İşlem</th>
              <th>Banka Adı</th>
              <th>Şirket</th>
              <th>Başlangıç Tarihi</th>
              <th>Bitiş Tarihi</th>
              <th>Önceki Taksit</th>
              <th>Yeni Taksit</th>
              <th>Önceki Vade</th>
              <th>Yeni Vade</th>
              <th>Kullanıcı</th>
              <th>Ip</th>
              <th>Açıklama</th>
            </tr>
          </thead>
          <tbody>
            {allHistory && allHistory.length > 0
              ? allHistory.map((ba, index) => (
                <tr role='row' className='odd' key={ba.Id || index}>
                  <td>{formatHistoryDate(ba.ChangeDate)}</td>
                  <td>{operationLabel(ba.OperationType)}</td>
                  <td>{ba.BankName}</td>
                  <td>
                    {state.companies.find(c => c.value.toString() === ba.Company?.toString())?.label || ''}
                  </td>
                  <td>{formatHistoryDate(ba.StartDate)}</td>
                  <td>{formatHistoryDate(ba.EndDate)}</td>
                  <td>{ba.OldInstallment}</td>
                  <td>{ba.NewInstallment}</td>
                  <td>{ba.OldInterestRate}</td>
                  <td>{ba.NewRate}</td>
                  <td>{ba.UserName}</td>
                  <td>{ba.UserIP}</td>
                  <td>{ba.Description}</td>
                </tr>
              ))
              : (
                <tr>
                  <td colSpan={13}>Tarihçe kaydı bulunamadı.</td>
                </tr>
              )}
          </tbody>
        </table>
        </div>
      </IPModal>
      <IPModal
        show={showInstallmentHistory}
        onClose={() => setBankInstallmentHistory(false)}
        hideConfirm={true}
        width={historyModalWidth(1900)}
        title='Taksit Tarihçe'
      >
        <div style={{ overflowX: 'auto' }}>
          <table
            id='datatable'
            className='table table-bordered table-hover dataTable'
            role='grid'
            aria-describedby='datatable_info'
            style={{ whiteSpace: 'nowrap' }}
          >
            <thead className='tableodd'>
              <tr role='row'>
                <th>Değişiklik Tarihi</th>
                <th>İşlem</th>
                <th>Açıklama</th>
                <th>Banka</th>
                <th>Önceki Taksit</th>
                <th>Yeni Taksit</th>
                <th>Önceki Oran</th>
                <th>Yeni Oran</th>
                <th>Önceki Başlangıç</th>
                <th>Yeni Başlangıç</th>
                <th>Önceki Bitiş</th>
                <th>Yeni Bitiş</th>
                <th>Kullanıcı Adı</th>
                <th>IP</th>
              </tr>
            </thead>
            <tbody>
              {installmentHistory && installmentHistory.length > 0 ? (
                installmentHistory.map((history, index) => {
                  const changed = (field: string) => history.ChangedFields?.includes(field) ?? false
                  return (
                    <tr role='row' className='odd' key={index}>
                      <td>{formatHistoryDate(history.ChangeDate)}</td>
                      <td>{operationLabel(history.OperationType)}</td>
                      <td>{history.Description || '–'}</td>
                      <td>{history.BankName || '–'}</td>
                      <td className={changed('Installment') ? 'font-weight-bold' : ''}>{history.OldInstallment}</td>
                      <td className={changed('Installment') ? 'font-weight-bold' : ''}>{history.NewInstallment}</td>
                      <td className={changed('InterestRate') ? 'font-weight-bold' : ''}>{history.OldRate}</td>
                      <td className={changed('InterestRate') ? 'font-weight-bold' : ''}>{history.NewRate}</td>
                      <td className={changed('StartDate') ? 'font-weight-bold' : ''}>{formatHistoryDate(history.OldStartDate)}</td>
                      <td className={changed('StartDate') ? 'font-weight-bold' : ''}>{formatHistoryDate(history.NewStartDate)}</td>
                      <td className={changed('EndDate') ? 'font-weight-bold' : ''}>{formatHistoryDate(history.OldEndDate)}</td>
                      <td className={changed('EndDate') ? 'font-weight-bold' : ''}>{formatHistoryDate(history.NewEndDate)}</td>
                      <td>{history.UserName || '–'}</td>
                      <td>{history.UserIp || '–'}</td>
                    </tr>
                  )
                })
              ) : (
                <tr>
                  <td colSpan={14}>Tarihçe kaydı bulunamadı.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </IPModal>
    </div>
  )
}
export default componentWithContext(BankUpdateDel)
